// extracted by mini-css-extract-plugin
export default {"titleText":"dark-styles_titleText__pb0X4","titleContainer":"dark-styles_titleContainer__2PXQc"};